import {CloseButton, CloseButtonProps, Dialog} from '@chakra-ui/react';

/** A dialog's top-right close button */
export function DialogCloseButton(props: CloseButtonProps) {
    return <Dialog.CloseTrigger asChild>
        <CloseButton size="md" {...props}/>
    </Dialog.CloseTrigger>;
}
